import FormConfig from "../formConfig.js";
import {
  fun_PostAction,
  fun_GetAction,
  fun_PDFPreview,
  fun_UploadImg,
  fun_Download
} from "@/api/index";
import { fun_GetKeys, fun_DownloadFile } from "@/utils/validate";
import { Loading } from "element-ui";
import CaLock from "@/components/common/calock";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import TenderRegistrationChoose from "../../components/tenderRegistrationChoose/index.vue";
import BiddingPlanChoose from "../../../components/biddingPlanChooseDialog/index.vue";
import Attachment from "../../../components/attachment/index.vue";
import PDFDialog from "../../../components/pdfDialog/index.vue";
import BiddingRegistration from "@/views/page/biddingScheme/biddingRegistration/details/index.vue";
export default {
  data() {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 工作台状态
      workbenchState: false,
      // 流程状态
      stepsActive: 0,
      // 流程数据
      stepsList: [
        {
          name: "项目信息",
          isSave: false, // 是否保存
          isActive: true, // 是否可点击
          icon: true, // 是否有必填项
          formList: FormConfig.tendererNoticeInfo()
        },
        {
          name: "招标计划信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.biddingPlanInfo()
        },
        {
          name: "公告内容",
          isSave: false,
          isActive: true,
          formList: FormConfig.prequalificationInfo()
        },
        {
          name: "招标文件信息",
          value: "nonEleBiddingDocumentInfo",
          isSave: false,
          isActive: true,
          formList: FormConfig.nonEleBiddingDocumentInfo()
        },
        {
          name: "招标文件信息",
          value: "biddingDocumentInfo",
          isSave: false,
          isActive: true,
          formList: FormConfig.biddingDocumentInfo()
        },
        {
          name: "其他",
          isSave: false,
          isActive: true,
          icon: false,
          formList: FormConfig.other()
        }
      ],
      // 招标登记信息弹窗
      bidDialog: false,
      // 表单配置
      formConfigList: [],
      // 表单绑定值
      form: {
        id: null, // 主键
        registrationId: null, // 招标登记编号
        tenderPrjName: null, // 招标项目名称
        constructionNo: null, // 报建编号
        sectionQuantity: null, // 标段数/采购包
        regulators: null, // 招投标监管部门
        registrationMode: null, // 招标文件（资格预审文件）下载方式
        registrationUrl: null, // 招标文件（资格预审文件）下载网址
        publicityDay: null, // 文件下载天数（天）
        noticeStartDate: null, // 文件下载起始时间
        noticeEndDate: null, // 文件下载截止时间
        bidDocumentSubmitEndDate: null, // 投标文件递交截止时间
        qualifiedBidNumber: null, // 合格投标人的数量
        evaluationMethod: null, // 评标办法
        otherRequirememts: null, // 其它要求
        totalInvestment: null, // 投资总额（万元）
        noticeState: null, // 公告状态
        tenderDocType: null, // 招标文件获取方式
        receiveDate: null, // 购领招标文件开始时间
        receiveEndDate: null, // 购领招标文件结束时间
        receiveAddress: null, // 购领招标文件地点
        offerPrice: null, // 招标文件发售价格（元）
        description: null, // 备注
        supervisionDeptTel: null, // 行政监督部门电话
        bulletinDuty: null, // 公告发布责任人
        bulletinMedia: null, // 公告发布媒体
        biddingPlanId: null, // 招标计划主键
        planInvestProjectCode: null, // 投资项目代码
        planInvestProjectName: null, // 投资项目名称
        planProjectName: null, // 招标项目名称
        planProjectPlace: null, // 招标项目建设地点
        planTenderProjectTypeName: null, // 招标项目类型
        planTenderTypeName: null, // 招标方式
        planTenderCorpName: null, // 招标人
        planIssueName: null, // 发布人名称
        planContractPrice: null, // 预估发包价（元）
        planNoticeReleaseTime: null, // 招标公告预计发布时间
        planReleaseTime: null, // 招标计划发布时间
        planRegulatorsName: null, // 招投标监管部门
        planProjectOverview: null, // 项目概况
        planTenderContent: null, // 招标内容
        acquisitionMode: null, // 资格预审文件获取方式
        publicityStartDate: null, // 资格预审结果公示开始时间
        publicityEndDate: null, // 资格预审结果公示截止时间
        fileDeliveryAddress: null, // 资格预审申请书送达地点
        resultNotificationDate: null, // 资格预审结果通知时间
        requisitionEndDate: null, // 资格预审申请书送达截止时间
        requisitionCorp: null, // 接收资格预审文件申请书单位
        decodeDuration: null, // 解密时长
        requisitionFilePath: null, // 资格预审文件路径
        modifyNoticeStateName: null, // 申请变更状态
        modifyMark: null, // 变更原因
        abnormalDescribe: null, // 异常情况描述
        stateName: null, // 状态名称
        tenderOpinion: null, // 招标人意见
        prequalificationType: null, // 资格预审审查方式
        bidNum: null, // 标段号
        state: null // 状态
      },
      // 错误提示
      errRules: {
        registrationId: null, // 招标登记编号
        tenderPrjName: null, // 招标项目名称
        constructionNo: null, // 报建编号
        sectionQuantity: null, // 标段数/采购包
        regulators: null, // 招投标监管部门
        registrationMode: null, // 招标文件（资格预审文件）下载方式
        registrationUrl: null, // 招标文件（资格预审文件）下载网址
        publicityDay: null, // 文件下载天数（天）
        noticeStartDate: null, // 文件下载起始时间
        noticeEndDate: null, // 文件下载截止时间
        bidDocumentSubmitEndDate: null, // 投标文件递交截止时间
        qualifiedBidNumber: null, // 合格投标人的数量
        evaluationMethod: null, // 评标办法
        otherRequirememts: null, // 其它要求
        totalInvestment: null, // 投资总额（万元）
        noticeState: null, // 公告状态
        tenderDocType: null, // 招标文件获取方式
        receiveDate: null, // 购领招标文件开始时间
        receiveEndDate: null, // 购领招标文件结束时间
        receiveAddress: null, // 购领招标文件地点
        offerPrice: null, // 招标文件发售价格（元）
        description: null, // 备注
        supervisionDeptTel: null, // 行政监督部门电话
        bulletinDuty: null, // 公告发布责任人
        bulletinMedia: null, // 公告发布媒体
        biddingPlanId: null, // 招标计划主键
        planInvestProjectCode: null, // 投资项目代码
        planInvestProjectName: null, // 投资项目名称
        planProjectName: null, // 招标项目名称
        planProjectPlace: null, // 招标项目建设地点
        planTenderProjectTypeName: null, // 招标项目类型
        planTenderTypeName: null, // 招标方式
        planTenderCorpName: null, // 招标人
        planIssueName: null, // 发布人名称
        planContractPrice: null, // 预估发包价（元）
        planNoticeReleaseTime: null, // 招标公告预计发布时间
        planReleaseTime: null, // 招标计划发布时间
        planRegulatorsName: null, // 招投标监管部门
        planProjectOverview: null, // 项目概况
        planTenderContent: null, // 招标内容
        acquisitionMode: null, // 资格预审文件获取方式
        publicityStartDate: null, // 资格预审结果公示开始时间
        publicityEndDate: null, // 资格预审结果公示截止时间
        fileDeliveryAddress: null, // 资格预审申请书送达地点
        resultNotificationDate: null, // 资格预审结果通知时间
        requisitionEndDate: null, // 资格预审申请书送达截止时间
        requisitionCorp: null, // 接收资格预审文件申请书单位
        decodeDuration: null, // 解密时长
        requisitionFilePath: null, // 资格预审文件路径
        modifyNoticeStateName: null, // 申请变更状态
        modifyMark: null, // 变更原因
        abnormalDescribe: null, // 异常情况描述
        stateName: null, // 状态名称
        tenderOpinion: null, // 招标人意见
        prequalificationType: null, // 资格预审审查方式
        bidNum: null, // 标段号
        state: null // 状态
      },
      // 核验次数
      auditCount: this.$route.query.auditCount,
      // 文件后缀名
      suffix: null,
      // 异常报告id
      reportId: null,
      // 异常报告新增或修改标识
      insUpdFlag: null,
      // 评标办法默认不置灰
      methodDisabled: false,
      // 默认显示公告状态
      isShowNoticeState: true,
      // 公告状态默认不置灰
      noticeStateDisabled: false,
      // 全局加载
      fullLoading: null,
      // 主键
      id: this.$route.query.id,
      // 招标人是否已盖章
      isTenderSignature: this.$route.query.isTenderSignature,
      // 操作类型
      controllerFlg: this.$route.query.controllerFlg,
      // 招标人签章状态
      tenderSignedState: null,
      // 是否需要核验
      isDeregulation: null,
      // pdf预览弹窗
      pdfDialogVisible: false,
      // pdf路径
      pdfUrl: null,
      // 资格预审文件列表loading
      preLoading: false,
      // 资格预审文件列表数据
      preTableData: [],
      // 资格预审文件列表基础数据
      preTableColumns: [
        {
          label: "预审文件编号",
          prop: "preFileCode"
        },
        {
          label: "标段号",
          prop: "section"
        },
        {
          label: "预审文件名称",
          prop: "prjName"
        },
        {
          label: "预审申请书送达截止时间",
          prop: "preFileEndTime"
        },
        {
          label: "操作",
          slotName: "requisitionFilePath"
        }
      ],
      // 资格预审文件列表分页
      preReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 资格预审文件列表总条数
      preTotal: 0,
      // 招标文件列表loading
      loading: false,
      // 招标文件列表数据
      tableData: [],
      // 招标文件列表基础数据
      tableColumns: [
        {
          label: "招标编号",
          prop: "id"
        },
        {
          label: "标段号",
          prop: "section"
        },
        {
          label: "招标文件名称",
          prop: "prjName"
        },
        // {
        //   label: "投标文件递交截止时间",
        //   prop: "bidEndDate"
        // },
        {
          label: "操作",
          slotName: "cz"
        }
      ],
      // 招标文件列表分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 招标文件列表总条数
      total: 0,
      // 非电子标招标文件列表loading
      nonEleLoading: false,
      // 非电子标招标文件列表数据
      nonEleTableData: [],
      // 非电子标招标文件列表基础数据
      nonEleTableColumns: [
        {
          label: "标段",
          prop: "section"
        },
        {
          label: "操作",
          slotName: "cz"
        }
      ],
      // 非电子标招标文件列表分页
      nonEleReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 非电子标招标文件列表总条数
      nonEleTotal: 0,
      // 非电子标招标文件列表按钮
      btnList: [],
      // 选中的数组
      multipleSelection: [],
      // 异议受理部门信息列表loading
      objectionLoading: false,
      // 异议受理部门信息数据
      objectionTableData: [],
      // 异议受理部门信息基础数据
      objectionTableColumns: [
        {
          label: "标段编号",
          prop: "section",
          minWidth: "120",
          fixed: true
        },
        {
          label: "名称",
          prop: "dissentDepartmentName",
          minWidth: "150"
        },
        {
          label: "地址",
          prop: "dissentDepartmentAddress",
          minWidth: "200"
        },
        {
          label: "联系人",
          prop: "dissentDepartmentLinkMan",
          minWidth: "100"
        },
        {
          label: "联系人手机",
          prop: "dissentDepartmentLink",
          minWidth: "150"
        },
        {
          label: "电子邮箱",
          prop: "dissentDepartmentEmail",
          minWidth: "150"
        }
      ],
      // 异议受理部门信息列表分页参数
      objectionReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 异议受理部门信息列表总条数
      objectionTotal: 0,
      // 是否显示招标计划按钮
      isShowPlanChoose: true,
      // 是否显示招标登记详情按钮
      isShowRegistration: true,
      // 默认不显示变更记录
      dialogVisible: false,
      // 变更记录loading
      modifyLoading: false,
      // 查询条件绑定值
      modifyForm: {
        modifyPerson: null, // 变更经办人
        modifyDate: null, // 变更时间
        modifyMark: null // 变更原因
      },
      // 查询条件基础数据
      formSearchList: [
        {
          type: "input",
          label: "变更经办人：",
          value: "modifyPerson",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "变更时间：",
          value: "modifyDate",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "变更原因：",
          value: "modifyMark",
          placeholder: "请输入"
        }
      ],
      // 变更记录列表数据
      modifyTableData: [],
      // 变更记录列表基础数据
      modifyTableColumns: [
        {
          label: "公告状态",
          prop: "noticeStateName"
        },
        {
          label: "变更经办人",
          prop: "modifyPerson"
        },
        {
          label: "变更时间",
          prop: "modifyDate"
        },
        {
          label: "变更原因",
          prop: "modifyMark"
        }
      ],
      // 变更记录分页参数
      modifyReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 变更记录总条数
      modifyTotal: 0,
      // 资格预审文件按钮默认不置灰
      prequalificationBtn: false,
      // 资格预审文件
      prequalificationFile: [],
      // 招标文件
      tenderFile: [],
      // 标段数下拉框
      optionData: [],
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null // 判断当前时提交还是退还至招标代理
      },
      // 招标登记详情弹窗默认不显示
      isBidDialogOpen: false,
      // 用于判断状态图片
      flagState: null
    };
  },

  // 注册组件
  components: {
    CaLock,
    AuditHistoryRecord,
    TenderRegistrationChoose,
    BiddingPlanChoose,
    Attachment,
    PDFDialog,
    BiddingRegistration
  },
  // 模板编译前
  created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu")
      ? sessionStorage.getItem("workbenchMenu")
      : null;
  },
  // 模板编译完成
  mounted() {
    // 默认获取第一个流程表单
    this.formConfigList = this.stepsList[this.stepsActive].formList;
    // 请求详情
    this.fun_Details();
  },
  // 自定义方法
  methods: {
    /**
     * 获取CA办理资料详情
     * @author shuhua
     */
    fun_Details() {
      // 开启遮罩
      this.fun_Loading();
      // 发起请求
      fun_GetAction("/tendererNotice/detail", {
        id: this.id,
        controllerFlg: this.controllerFlg,
        isTenderSignature: this.isTenderSignature
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 如果主键为空
          if(!this.id){
            // 重新赋值主键
            this.id = data.data.id;
          }
          // 表格数据
          this.form = data.data;
          // 工作台状态
          this.workbenchState = data.workbenchState;
          // 获取状态用于判断显示图片
          this.flagState = data.data.state;
          // 转换成字符串
          this.form.totalInvestment = this.form.totalInvestment
            ? this.form.totalInvestment.toString()
            : "";
          // 转换成字符串
          this.form.offerPrice = this.form.offerPrice
            ? this.form.offerPrice.toString()
            : "";
          // 核验次数
          this.auditCount = data.auditCount;
          // 根据操作类型切换模块显示
          this.fun_ChangeFormConfigListByType(this.form);
          // 根据操作类型切换模块显示
          this.fun_ChangeFormConfigListByIsAuditOk(this.form);
          // 资格预审文件后缀名
          this.suffix = data.suffix;
          // 异常报告id
          this.reportId = data.reportId;
          // 异常报告新增或修改标识
          this.insUpdFlag = data.insUpdFlag;
          // 根据资格核验方式判断是否显示预审信息
          this.fun_PrequalificationType();
          // 异议部门信息
          this.fun_DissentDepartmentList();
          // 工作人员
          if (this.userFlag === "工作人员") {
            // 遍历流程
            this.stepsList.map(e => {
              // 匹配流程资格预审文件信息
              if (e.name === "公告内容") {
                // 遍历标签页
                e.formList.map(formList => {
                  // 遍历表单
                  formList.formConfigList.map((item, index) => {
                    // 匹配资格预审文件上传
                    if (item.value === "requisitionFilePath") {
                      // 删除
                      formList.formConfigList.splice(index, 1);
                    }
                  });
                });
              }
            });
          }
          // 资格预审文件上传按钮显示
          this.prequalificationBtn = false;
          // 设置甲方确认
          this.fun_GetTenderSignature(data);
          // 非电子标资格后审
          if (
            this.form.ebsFlag === "0" &&
            this.form.prequalificationType === "2"
          ) {
            // 判断是否插入流程
            let rtn = true;
            // 遍历流程
            this.stepsList.map(e => {
              // 匹配流程招标文件信息（非电子标）
              if (e.value === "nonEleBiddingDocumentInfo") {
                // 存在流程，修改标识
                rtn = false;
              }
            });
            // 不存在，插入流程
            if (rtn) {
              // 插入流程招标文件信息（非电子标）
              this.stepsList.splice(1, 0, {
                name: "招标文件信息",
                value: "nonEleBiddingDocumentInfo",
                isSave: false,
                isActive: true,
                formList: FormConfig.nonEleBiddingDocumentInfo()
              });
            }
            // 获取标段下拉框的值
            this.fun_SetSectionCombobox();
            // 获取招标文件信息
            this.fun_TenderFilePathList();
          } else {
            // 遍历流程
            this.stepsList.map((e, i) => {
              // 匹配招标文件信息（非电子标）
              if (e.value === "nonEleBiddingDocumentInfo") {
                // 删除
                this.stepsList.splice(i, 1);
              }
            });
          }
          // 招标计划id不为空
          if (this.form.biddingPlanId) {
            // 加载招标计划
            this.fun_BiddingPlan(this.form.biddingPlanId);
          } else {
            // 删除招标计划
            this.stepsList.map((e, i) => {
              // 匹配流程招标计划信息
              if (e.name === "招标计划信息") {
                // 删除
                this.stepsList.splice(i, 1);
              }
            });
          }
          // 加载框取消
          this.fullLoading.close();
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },

    /**
     * 根据操作类型切换模块显示
     * @author shuhua
     */
    fun_ChangeFormConfigListByType(data) {
      // 新增
      if (this.controllerFlg === "insert") {
        // 招标登记编号为空
        if (!data.registrationId) {
          // 招标登记详情按钮不显示
          this.isShowRegistration = false;
          // 招标计划按钮不显示
          this.isShowPlanChoose = false;
        }
        // 遍历
        this.stepsList.map(e => {
          // 匹配步骤其他
          if (e.name === "其他") {
            // 遍历
            e.formList.map((formList, index) => {
              // 匹配CA预约
              if (formList.title === "招标异常情况") {
                // 删除
                e.formList.splice(index, 1);
              }
            });
          }
        });
      }
      // 修改
      if (this.controllerFlg === "update") {
        // 资格预审或电子标
        if (data.prequalificationType === "1" || data.ebsFlag === "1") {
          // 遍历
          this.stepsList.map(e => {
            // 匹配步骤招标公告信息
            if (e.name === "项目信息") {
              // 遍历
              e.formList.map(formList => {
                // 遍历表单
                formList.formConfigList.map((item, index) => {
                  // 资格预审，评标办法
                  if (data.prequalificationType === "1" && item.value === "evaluationMethod") {
                    // 删除
                    formList.formConfigList.splice(index, 1);
                  }
                })
              });
            }
          });
        }
      }
      // 操作类型为查看详情
      if (this.controllerFlg === "detail") {
        // 公告置灰
        this.noticeStateDisabled = true;
        // 遍历
        this.stepsList.map(e => {
          // 遍历标签页
          e.formList.map(formList => {
            // 遍历标签页内表单
            formList.formConfigList.map(form => {
              // 置灰
              form.disabled = true;
            });
          });
          // 资格预审
          if (data.prequalificationType === "1") {
            // 匹配步骤招标公告信息
            if (e.name === "项目信息") {
              // 遍历
              e.formList.map(formList => {
                // 遍历标签页内表单
                formList.formConfigList.map((item, index) => {
                  // 资格预审，评标办法
                  if (item.value === "evaluationMethod") {
                    // 删除
                    formList.formConfigList.splice(index, 1);
                  }
                });
              });
            }
          }
          // 匹配流程招标文件信息（非电子标）
          if (e.value === "nonEleBiddingDocumentInfo") {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历表单
              formList.formConfigList.map((item, index) => {
                // 匹配招标文件上传按钮
                if (item.slotName === "bidDocument") {
                  // 删除招标文件上传按钮
                  formList.formConfigList.splice(index, 1);
                }
              });
            });
          }
          // 匹配步骤其他
          if (e.name === "其他") {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历表单
              formList.formConfigList.map((item, index) => {
                // 匹配电子签名
                if (item.title === "电子签名") {
                  // 删除
                  formList.formConfigList.splice(index, 1);
                }
              });
            });
          }
        });
        // 资格后审
        if (data.prequalificationType !== "1") {
          // 评标办法置灰
          this.methodDisabled = true;
        }
        // 查看招标计划按钮不显示
        this.isShowPlanChoose = false;
      } else {
        // 如果核验状态为通过
        if (data.isAuditOk == "tg") {
          // 查看招标计划按钮不显示
          this.isShowPlanChoose = false;
        }
        // 电子评审
        // if (data.prequalificationShape === "0") {
        //   // 判断资格预审客户端里资格预审截止时间是否填完
        //   this.fun_PreRequisitionEndDateJudge();
        // }
        // 遍历
        this.stepsList.map(e => {
          // 匹配步骤资格预审公告信息
          if (e.name === "公告内容") {
            // 遍历
            e.formList.map(formList => {
              // 遍历
              formList.formConfigList.map((item, index) => {
                // 资格预审结果通知时间
                if (item.value === "resultNotificationDate") {
                  // 置灰
                  item.disabled = true;
                }
              });
            });
          }
          // 匹配步骤招标公告信息
          if (e.name === "项目信息") {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历表单
              formList.formConfigList.map((item, index) => {
                // 匹配文件下载天数（天）
                if (item.value === "publicityDay") {
                  // 删除
                  formList.formConfigList.splice(index, 1);
                }
                // 资格预审结果通知时间
                if (item.value === "offerPrice") {
                  // 电子标
                  if (data.ebsFlag === "1") {
                    // 置灰
                    item.disabled = true;
                  } else {
                    // 取消置灰
                    item.disabled = false;
                  }
                }
              });
            });
          }
        });
      }
    },

    /**
     * 根据核验状态切换模块显示
     */
    fun_ChangeFormConfigListByIsAuditOk(data) {
      // 有过核验通过记录的场合
      if (data.isAuditOk === "tg") {
        // 评标办法置灰
        this.methodDisabled = true;
        // 置灰资格预审文件上传按钮
        this.prequalificationBtn = true;
        // 遍历流程
        this.stepsList.map(e => {
          // 遍历标签页
          e.formList.map(formList => {
            // 遍历表单
            formList.formConfigList.map(item => {
              // 置灰
              item.disabled = true;
            });
          });
          // 匹配步骤招标文件信息（非电子标）
          if (e.value === "nonEleBiddingDocumentInfo") {
            // 遍历
            e.formList.map(formList => {
              // 遍历
              formList.formConfigList.map((item, index) => {
                // 上传非电子标招标文件按钮
                if (item.slotName === "bidDocument") {
                  // 删除
                  formList.formConfigList.splice(index, 1);
                }
              });
            });
          }
          // 操作类型不是查看详情
          if (this.controllerFlg != "detail") {
            // 匹配步骤其他
            if (e.name === "其他") {
              // 遍历
              e.formList.map(formList => {
                // 公告变更信息或招标异常情况
                if (
                  formList.title === "公告变更信息" ||
                  formList.title === "招标异常情况"
                ) {
                  // 遍历标签页内表单
                  formList.formConfigList.map(item => {
                    // 变更原因
                    if (item.value === "modifyMark") {
                      // 取消置灰
                      item.disabled = false;
                    }
                    // 异常描述
                    if (item.value === "abnormalDescribe") {
                      // 取消置灰
                      item.disabled = false;
                    }
                  });
                }
              });
            }
          }
          // 资格预审时，匹配步骤招标公告信息
          if (data.prequalificationType === "1" && e.name === "项目信息") {
            // 遍历
            e.formList.map(formList => {
              // 遍历标签页内表单
              formList.formConfigList.map((item, index) => {
                // 匹配评标办法
                if (item.value === "evaluationMethod") {
                  // 删除
                  formList.formConfigList.splice(index, 1);
                }
              });
            });
          }
          // 操作类型不是查看详情
          if (this.controllerFlg != "detail") {
            // 公告状态可选
            this.noticeStateDisabled = false;
          }
        });
        // 根据公告状态选择是否出现作废框
        this.fun_CancelDivShow();
      } else {
        // 置灰评标办法
        this.methodDisabled = true;
        // 遍历流程
        this.stepsList.map(e => {
          // 匹配流程招标公告信息
          if (e.name === "项目信息") {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历表单
              formList.formConfigList.map((item, index) => {
                // 匹配公告状态
                if (item.value === "noticeState") {
                  // 删除
                  formList.formConfigList.splice(index, 1);
                }
              });
            });
          }
          // 匹配其他流程
          if (e.name === "其他") {
            // 非必填
            e.icon = false;
            // 获取标签页的长度
            let index = e.formList.length;
            // 遍历
            while (index--) {
              // 匹配公告变更信息
              if (e.formList[index].title === "公告变更信息") {
                // 删除
                e.formList.splice(index, 1);
              }
              // 匹配招标异常情况
              if (e.formList[index].title === "招标异常情况") {
                // 删除
                e.formList.splice(index, 1);
              }
            }
          }
        });
        // 如果是建设工程项目
        if (this.form.isConstructionProject === "1") {
          // 显示招标计划按钮
          this.isShowPlanChoose = true;
        } else {
          // 隐藏招标计划按钮
          this.isShowPlanChoose = false;
        }
      }
    },

    /**
     * 公告状态下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeNoticeState(e) {
      // 赋值
      this.form.noticeState = e.code;
      // 根据公告状态选择是否出现作废框
      this.fun_CancelDivShow();
    },

    /**
     * 评标办法值改变事件
     */
    fun_ChangeMethod(e) {
      // 赋值
      this.form.evaluationMethod = e.code;
    },

    /**
     * 资格预审文件信息/招标文件信息下载
     * @author shuhua
     */
    fun_Filedownload(data, type) {
      // 打开弹窗
      this.$refs.pdfDialog.dialogVisible = true;
      // 资格预审
      if (this.form.prequalificationType === "1") {
        // 弹窗标题
        this.$refs.pdfDialog.title = "资格预审文件查看";
      } else {
        // 弹窗标题
        this.$refs.pdfDialog.title = "招标文件查看";
      }
      // 延迟执行
      this.$nextTick(() => {
        // pdf路径
        let pdfurl = fun_PDFPreview(data.filePath);
        // 非电子标招标文件
        if (type === "nonEle") {
          // pdf 路径
          pdfurl = fun_PDFPreview(data.tenderFilePath);
        }
        // 赋值
        this.$refs.pdfDialog.$refs.iframe.src =
          "./static/pdf/web/viewer.html?file=" + encodeURIComponent(pdfurl);
      });
    },
    /**
     * 保存/提交的方法
     * @author shuhua
     */
    fun_NoticeInsUpd(state) {
      // 获取评标办法的值
      let evaluationMethod = this.form.evaluationMethod;
      // 资格后审
      if (this.form.prequalificationType === "2") {
        // 如果评标办法为空且项目为电子标
        if ((evaluationMethod === "" || evaluationMethod === null) && this.form.ebsFlag === "1") {
          this.$alert("请至招标登记中完善评标办法，并制作招标文件！", "warning");
          return;
        }
      }
      // 如果评标办法为空且项目为非电子标
      if ((evaluationMethod == "" || evaluationMethod == null) && this.form.ebsFlag === "0") {
        this.$alert("请至招标登记中完善评标办法，并在招标公告中上传招标文件！", "warning");
        return;
      }
      // 公告状态为正常
      if (this.form.noticeState === "0") {
        // 填写的投标文件递交截止日期不为空，并且为资格预审项目时
        if (this.form.bidDocumentSubmitEndDate !== null && this.form.bidDocumentSubmitEndDate !== "") {
          // 如果文件下载截止时间不为空
          if (this.form.noticeEndDate !== null && this.form.noticeEndDate !== "") {
            // 投标文件递交截止时间所填写的要大于最小文件下载截止日期
            if (this.form.bidDocumentSubmitEndDate < this.form.noticeEndDate) {
              this.$alert("投标文件递交截止时间须大于文件下载截止时间！", "warning");
              return;
            }
          }
        }
      }
      // 保存
      if (state === "bc") {
        // 如果是审核通过
        if(this.form.isAuditOk == "tg"){
          // 自定义下标
          let i = 0;
          // 验证当前表单
          this.$refs.collapseForm.$refs.enInform.validate(valid => {
            // 验证通过
            if (valid) {
              // 重置表单
              this.formConfigList = this.stepsList[i].formList;
              this.$nextTick(() => {
                // 验证表单
                this.fun_AuditOkVal(i, state);
              });
            } else {
              // 提示
              this.$alert("页面存在错误信息，请检查后重试！", "warning");
              return false;
            }
          });
        }
        // 如果不是审核通过
        else{
          // 状态
          this.form.state = "bc";
          // 提交的方法
          this.fun_Submit(state);
        }
      } else {
        // 自定义下标
        let i = 0;
        // 验证当前表单
        this.$refs.collapseForm.$refs.enInform.validate(valid => {
          // 验证通过
          if (valid) {
            // 重置表单
            this.formConfigList = this.stepsList[i].formList;
            this.$nextTick(() => {
              // 验证表单
              this.fun_val(i, state);
            });
          } else {
            // 提示
            this.$alert("页面存在错误信息，请检查后重试！", "warning");
            return false;
          }
        });
      }
    },
    /**
     * 验证表单
     * @param {*} i tabs切换
     */
    fun_AuditOkVal(i, state) {
      // 验证第一个表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          // 最后一个表单
          if (i === this.stepsList.length - 1) {
            // 操作状态
            this.form.state = state;
            // 提交的方法
            this.fun_Submit(state);
          } else {
            this.formConfigList = this.stepsList[i + 1].formList;
            this.$nextTick(()=>{
              // 递归验证表单
              this.fun_AuditOkVal(i + 1, state);
            })
          }
        } else {
          // 定位到未填表单
          this.stepsActive = i;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      })
    },
    /**
     * 验证表单
     * @param {*} i tabs切换
     */
    fun_val(i, state) {
      // 验证第一个表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          // 最后一个表单
          if (i === this.stepsList.length - 1) {
            // 操作状态
            this.form.state = state;
            // 提交前验证
            this.fun_Validated();
          } else {
            this.formConfigList = this.stepsList[i + 1].formList;
            this.$nextTick(()=>{
              // 递归验证表单
              this.fun_val(i + 1, state);
            })
          }
        } else {
          // 定位到未填表单
          this.stepsActive = i;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      })
    },
    /**
     * 提交前验证
     */
    fun_Validated(){
      // 定义formData
      let formData = new FormData();
      // 主键
      formData.append("id", this.id);
      // 表单数据
      formData.append("tendererNotices", JSON.stringify(this.form));
      // 核验条数
      formData.append("auditCount", this.auditCount);
      // 存在资格预审文件
      if (this.prequalificationFile.length > 0) {
        // 资格预审文件
        formData.append("file", this.prequalificationFile[0].raw);
      }
      // 异常报告id
      formData.append("reportId", this.reportId);
      // 异常报告新增或修改标识
      formData.append("insUpdFlag", this.insUpdFlag);
      // 开启遮罩
      this.fun_Loading();
      // 发起请求
      fun_UploadImg("/tendererNotice/validated", formData, 0).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 开启弹窗
          this.$refs.caLock.dialogCalock = true;
          // 签名数据
          this.$refs.caLock.data =
            this.form.registrationId +
            this.form.tenderPrjName +
            this.form.sectionQuantity +
            this.form.registrationMode +
            this.form.noticeEndDate +
            this.form.regulators;
          // 状态
          this.$refs.caLock.state = this.form.state;
        } else {
          // 错误消息不为空
          if (data) {
            // 消息不为空
            if (data.msg) {
              // 错误提示
              this.$alert(data.msg, "warning");
            } else {
              // 定义rules为一个随机数
              this.errRules = Math.random();
              // 执行延迟方法
              this.$nextTick(() => {
                // 错误提示
                this.$alert("输入内容存在错误，请点击流程查看提示内容，根据提示进行修改！", "warning");
                // 赋值错误消息
                this.errRules = res.data.data;
              });
            }
          } else {
            // 加载框取消
            this.fullLoading.close();
            // 返回错误消息
            this.$message.error(msg);
          }
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 操作状态
      this.form.state = state;
      // 提交的方法
      this.fun_Submit();
    },
    /**
     * 提交的方法
     * @author shuhua
     */
    fun_Submit(state) {
      // 如果是保存
      if (this.form.state == "bc" && !this.form.tenderPrjName) {
        // 错误提示
        this.$alert("请优先选择招标项目信息！", "warning");
        return false;
      }
      // 定义formData
      let formData = new FormData();
      // 主键
      formData.append("id", this.id);
      // 表单数据
      formData.append("tendererNotices", JSON.stringify(this.form));
      // 核验条数
      formData.append("auditCount", this.auditCount);
      // 存在资格预审文件
      if (this.prequalificationFile.length > 0) {
        // 资格预审文件
        formData.append("file", this.prequalificationFile[0].raw);
      }
      // 异常报告id
      formData.append("reportId", this.reportId);
      // 异常报告新增或修改标识
      formData.append("insUpdFlag", this.insUpdFlag);
      // 开启遮罩
      this.fun_Loading();
      // 发起请求
      fun_UploadImg("/tendererNotice/saveOrUpdate", formData, 0).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 回调
          this.id = data.id;
          // 设置主键
          this.form.id = data.id;
          // 加载框取消
          this.fullLoading.close();
          // 判断有传值
          if (state) this.$message.success(msg);
          // 如果不是保存
          if (this.form.state != "bc") {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.$router.back();
          } else {
            this.controllerFlg = "update";
          }
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 关闭倒计时询问框
          this.$refs.dialogSetInterval.dialogVisible = false;
          // 错误消息不为空
          if (data) {
            // 消息不为空
            if (data.msg) {
              // 错误提示
              this.$alert(data.msg, "warning");
            } else {
              // 定义rules为一个随机数
              this.errRules = Math.random();
              // 执行延迟方法
              this.$nextTick(() => {
                // 错误提示
                this.$alert("输入内容存在错误，请点击流程查看提示内容，根据提示进行修改！", "warning");
                // 赋值错误消息
                this.errRules = res.data.data;
              });
            }
          } else {
            // 加载框取消
            this.fullLoading.close();
            // 返回错误消息
            this.$message.error(msg);
          }
        }
      });
    },
    /**
     * 资格预审申请书送达截止时间样式
     */
    fun_PreRequisitionEndDateStyle(){
      // 电子评审
      if (this.form.prequalificationShape === "0") {
        // 清空资格预审申请书送达截止时间
        this.form.requisitionEndDate = "";
        // 遍历流程
        this.stepsList.map(e => {
          // 匹配流程资格预审公告信息
          if (e.name === "公告内容") {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历表单
              formList.formConfigList.map((item, index) => {
                // 资格预审申请书送达截止时间
                if (item.value === "requisitionEndDate") {
                  // 删除
                  formList.formConfigList.splice(index, 1);
                }
              });
            });
          }
        });
      }
      // 如果是非电子评审
      else if (this.form.prequalificationShape === "1"){
        // 数量
        let num = 0;
        // 下标
        let index = 0;
        // 遍历流程
        this.stepsList.map(e => {
          // 匹配流程资格预审公告信息
          if (e.name === "公告内容") {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历表单
              formList.formConfigList.map((item, i) => {
                // 资格预审申请书送达截止时间
                if (item.value === "requisitionEndDate") {
                  num++;
                }
                // 资格预审结果通知时间
                if (item.value === "resultNotificationDate") {
                  index = i;
                }
              });
            });
          }
        });
        // 如果不存在
        if(num == 0){
          // 遍历流程
          this.stepsList.map(e => {
            // 匹配其他流程
            if (e.name === "公告内容") {
              // 在公告变更信息后插入招标异常情况
              e.formList.splice(index + 1, 0, {
                label: "资格预审申请书送达截止时间：",
                value: "requisitionEndDate",
                type: "date",
                dateType: "datetime",
                disabled: false,
                valueFormat: "yyyy-MM-dd HH:mm",
                format: "yyyy-MM-dd HH:mm",
                TimePickerOptions: {
                  disabledDate(time) {
                    //此条为设置禁止用户选择今天之前的日期，包含今天。
                    return time.getTime() <= (Date.now());
                  },
                },
              });
            }
          });
        }
      }
    },
    /**
     * 验证客户端资格预审申请书送达截止时间是否全部填写完的方法
     * @author shuhua
     */
    fun_PreRequisitionEndDateJudge() {
      // 发起请求
      fun_PostAction("/tendererNotice/checkPreRequisitionEndDateJudge", {
        id: this.form.registrationId,
        sectionQuantity: this.form.sectionQuantity
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 返回结果为true
          if (data) {
            // 清空资格预审申请书送达截止时间
            this.form.requisitionEndDate = "";
            // 遍历流程
            this.stepsList.map(e => {
              // 匹配流程资格预审公告信息
              if (e.name === "公告内容") {
                // 遍历标签页
                e.formList.map(formList => {
                  // 遍历表单
                  formList.formConfigList.map((item, index) => {
                    // 资格预审申请书送达截止时间
                    if (item.value === "requisitionEndDate") {
                      // 置灰
                      item.disabled = true;
                    }
                  });
                });
              }
            });
          } else {
            // 遍历流程
            this.stepsList.map(e => {
              // 匹配流程资格预审公告信息
              if (e.name === "公告内容") {
                // 遍历标签页
                e.formList.map(formList => {
                  // 遍历表单
                  formList.formConfigList.map(item => {
                    // 资格预审申请书送达截止时间
                    if (item.value === "requisitionEndDate") {
                      // 置灰
                      item.disabled = false;
                    }
                  });
                });
              }
            });
          }
        }
      });
    },
    /**
     * 根据公告状态选择是否出现作废框
     * @author shuhua
     */
    fun_CancelDivShow() {
      // 公告状态
      let noticeState = this.form.noticeState;
      // 公告作废
      if (noticeState === "1" || noticeState === "2" || noticeState === "3") {
        // 标识
        let num = 0;
        // 下标
        let index = 0;
        // 遍历流程
        this.stepsList.map(e => {
          // 匹配其他流程
          if (e.name === "其他") {
            // 必填
            e.icon = true;
            // 遍历标签页
            e.formList.map((formList, i) => {
              // 匹配招标异常情况
              if (formList.title === "招标异常情况") {
                // 修改标识
                num++;
              }
              // 匹配公告变更信息
              if (formList.title !== "公告变更信息") {
                // 赋值
                index = i;
              }
            });
          }
        });
        // 不存在招标异常情况
        if (num == 0) {
          // 遍历流程
          this.stepsList.map(e => {
            // 匹配其他流程
            if (e.name === "其他") {
              // 在公告变更信息后插入招标异常情况
              e.formList.splice(index + 1, 0, {
                title: "招标异常情况",
                name: "3",
                icon: "",
                tipsList: [
                  {
                    text:
                      "“异常描述”将作为变更公告主体内容和招标异常报告主体内容在交易平台公示,请谨慎填写！"
                  }
                ],
                class: "abnormalCondition",
                formConfigList: [
                  {
                    label: "异常描述：",
                    value: "abnormalDescribe",
                    type: "textarea",
                    width: "100%;",
                    maxlength: 1250,
                    tip: "可填1250个汉字",
                    required: true,
                    disabled: false,
                    rule: {
                      required: true,
                      message: "该输入项不能为空",
                      trigger: "blur"
                    }
                  },
                  {
                    label: "异常说明附件：",
                    type: "slot",
                    slotName: "uploadBtn"
                  }
                ]
              });
            }
          });
        }
        // 如果是详情
        if(this.controllerFlg == "detail"){
          // 遍历流程
          this.stepsList.map(e => {
            // 匹配其他
            if (e.name === "其他") {
              // 遍历标签页
              e.formList.map(formList => {
                // 遍历表单
                formList.formConfigList.map(item => {
                  // 异常描述
                  if (item.value === "abnormalDescribe") {
                    // 置灰
                    item.disabled = true;
                  }
                });
              });
            }
          });
        }
      } else {
        // 遍历流程
        this.stepsList.map(e => {
          // 匹配其他流程
          if (e.name === "其他") {
            // 遍历标签页
            e.formList.map((formList, index) => {
              // 存在公告变更信息
              if (formList.title === "公告变更信息") {
                // 必填
                e.icon = true;
              }
              // 匹配招标异常情况
              if (formList.title === "招标异常情况") {
                // 删除
                e.formList.splice(index, 1);
              }
            });
          }
        });
        // 清空异常情况值
        this.form.abnormalDescribe = null;
      }
      // 不等于延期
      if (noticeState !== "1") {
        // 遍历流程
        this.stepsList.map(e => {
          // 匹配流程招标公告信息
          if (e.name === "项目信息") {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历表单
              formList.formConfigList.map(item => {
                if (
                  item.value === "noticeEndDate" || // 文件下载截止时间
                  item.value === "publicityEndDate" || // 资格预审结果公示截止时间
                  item.value === "publicityStartDate" || // 资格预审结果公示起始时间
                  item.value === "resultNotificationDate" || // 资格预审结果通知时间
                  item.value === "requisitionEndDate" || // 资格预审申请书送达截止时间
                  item.value === "receiveDate" || // 购领招标文件时间
                  item.value === "receiveEndDate" // 购领招标文件结束时间
                ) {
                  // 置灰
                  item.disabled = true;
                }
              });
            });
          }
        });
      }
    },
    /**
     * 招标登记信息
     * @author shuhua
     */
    fun_TenderRegistrationChoose() {
      // 打开弹窗
      this.$refs.tenderRegistrationChoose.dialogVisible = true;
      // 请求集合
      this.$refs.tenderRegistrationChoose.fun_GetList();
    },
    /**
     * 查看招标登记详情
     * @author shuhua
     */
    fun_LookRegistrationDetails() {
      // 打开弹窗
      this.bidDialog = true;
    },

    /**
     * 招标计划信息
     * @author shuhua
     */
    fun_BiddingPlanChooseList() {
      // 打开弹窗
      this.$refs.biddingPlanChoose.dialogVisible = true;
      // 请求集合
      this.$refs.biddingPlanChoose.fun_GetList(this.form.registrationId);
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 打开历史记录弹窗
     * @author shuhua
     */
    fun_OpenModifyHistoryRecord() {
      // 打开弹窗
      this.dialogVisible = true;
      // 获取招标/资格预审公告变更记录
      this.fun_GetHistoryList();
    },
    /**
     * 设置项目信息
     * @author shuhua
     */
    fun_SetTenderRegistration(e) {
      // 招标登记编号
      this.form.registrationId = e.id;
      // 显示招标登记详情按钮
      this.isShowRegistration = true;
      // 显示招标计划按钮
      this.isShowPlanChoose = true;
      // 报建编号
      this.form.constructionNo = e.constructionNo;
      // 项目名称
      this.form.tenderPrjName = e.tenderPrjName;
      // 标段数
      this.form.sectionQuantity = e.sectionQuantity.toString();
      // 资格核验方式
      this.form.prequalificationType = e.prequalificationType;
      // 招标投标监管部门
      this.form.regulators = e.regulators;
      // 资格预审形式
      this.form.prequalificationShape = e.prequalificationShape;
      // 是否电子标
      this.form.ebsFlag = e.ebsFlag;
      // 招标类别
      this.form.tenderClassNum = e.tenderClassNum;
      // 评标办法
      this.form.evaluationMethod = e.evaluationMethod;
      // 是否核验
      this.form.isAudit = e.isAudit;
      // 是否建设工程项目
      this.form.isConstructionProject = e.isConstructionProject;
     
      // 如果是非电子标并且评标办法不为空
      if (!this.form.evaluationMethod && this.form.ebsFlag === "0") {
        // 评标办法可选
        this.methodDisabled = false;
      } else {
        // 评标办法置灰
        this.methodDisabled = true;
      }
      // 根据资格审查方式判断显示
      this.fun_PrequalificationType();
      // 异议部门信息
      this.fun_DissentDepartmentList();
      // 获取标段编号
      this.fun_SetSectionCombobox();
      // 根据是否电子标判断显示
      if (this.form.ebsFlag === "0" && this.form.prequalificationType === "2") {
        // 下标
        let index = 0;
        // 判断是否插入招标文件（非电子标）标识
        let flag = true;
        // 遍历流程
        this.stepsList.map((e, i) => {
          // 匹配流程招标公告信息
          if (e.name === "项目信息") {
            // 获取下标
            index = i;
          }
          // 匹配流程招标文件信息（非电子标）
          if (e.value === "nonEleBiddingDocumentInfo") {
            // 存在
            flag = false;
          }
        });
        // 判断是否存在
        if (flag) {
          // 插入
          this.stepsList.splice(index + 1, 0, {
            name: "招标文件信息",
            value: "nonEleBiddingDocumentInfo",
            isSave: false,
            isActive: true,
            formList: FormConfig.nonEleBiddingDocumentInfo()
          });
        }
        // 招标文件一览
        this.fun_TenderFilePathList();
      } else {
        // 遍历流程
        this.stepsList.map((e, i) => {
          // 匹配流程招标文件信息（非电子标）
          if (e.value === "nonEleBiddingDocumentInfo") {
            // 删除
            this.stepsList.splice(i, 1);
          }
        });
      }
    },
    /**
     * 根据资格审查方式判断显示
     * @author shuhua
     */
    fun_PrequalificationType() {
      // 设置资格预审申请书送达截止时间
      this.fun_PreRequisitionEndDateStyle();
      // 对投标人资格预审形式不为空
      if (this.form.prequalificationType) {
        // 资格后审
        if (this.form.prequalificationType === "2") {
          // 声明需要过滤掉的数据
          let arr = ["公告内容"];
          // 删除流程
          this.stepsList = this.stepsList.filter(
            item => !arr.includes(item.name)
          );
          // 标识
          let rtn = true;
          // 下标
          let index = 0;
          // 遍历
          this.stepsList.map((e, i) => {
            // 匹配招标公告信息
            if (e.name === "项目信息") {
              // 遍历标签页
              e.formList.map(formList => {
                // 遍历表单
                formList.formConfigList.map(item => {
                  // 匹配评标办法
                  if (item.value === "evaluationMethod") {
                    // 必填
                    item.required = true;
                    item.rule.required = true;
                  }
                  // 匹配文件下载方式
                  else if (item.value === "registrationMode") {
                    // 重新赋值
                    item.label = "招标文件下载方式：";
                  }
                  // 匹配文件下载网址
                  else if (item.value === "registrationUrl") {
                    // 重新赋值
                    item.label = "招标文件下载网址：";
                  }
                });
              });
            }
            // 电子标
            if (this.form.ebsFlag === "1") {
              // 匹配流程招标计划信息
              if (e.name === "招标计划信息") {
                // 赋值
                index = i;
              }
              // 匹配流程招标文件信息
              if (e.value === "biddingDocumentInfo") {
                // 修改标识
                rtn = false;
              }
              // 获取招标文件信息
              this.fun_EbTendererFileList();
            } else {
              // 匹配流程招标文件信息
              if (e.value === "biddingDocumentInfo") {
                // 删除
                this.stepsList.splice(i, 1);
              }
            }
          });
          // 标识--不存在招标文件信息
          if (rtn && this.form.ebsFlag === "1") {
            // 插入
            this.stepsList.splice(index + 1, 0, {
              name: "招标文件信息",
              value: "biddingDocumentInfo",
              isSave: false,
              isActive: true,
              formList: FormConfig.biddingDocumentInfo()
            });
          }
          // 资格预审
        } else {
          // 标识
          let rtn = true;
          // 文件标识
          let fileRtn = true;
          // 遍历
          this.stepsList.map((e, i) => {
            // 匹配招标公告信息
            if (e.name === "项目信息") {
              // 遍历标签页
              e.formList.map(formList => {
                // 遍历表单
                formList.formConfigList.map(item => {
                  // 匹配评标办法
                  if (item.value === "evaluationMethod") {
                    // 取消必填
                    item.required = false;
                    item.rule.required = false;
                  }
                  // 匹配文件下载方式
                  else if (item.value === "registrationMode") {
                    // 重新赋值
                    item.label = "资格预审文件下载方式：";
                  }
                  // 匹配文件下载网址
                  else if (item.value === "registrationUrl") {
                    // 重新赋值
                    item.label = "资格预审文件下载网址：";
                  }
                });
              });
            }
            // 匹配流程资格预审公告信息
            if (e.name === "公告内容") {
              // 存在资格预审公告信息，修改标识
              rtn = false;
            }
            // 匹配流程招标文件信息
            if (e.value === "biddingDocumentInfo") {
              // 删除
              this.stepsList.splice(i, 1);
            }
          });
          // 不存在资格预审公告信息
          if (rtn) {
            // 资格预审公告信息插入位置
            let index = 0;
            // 遍历流程
            this.stepsList.map((e, i) => {
              // 匹配流程招标计划信息
              if (e.name === "招标计划信息") {
                // 下标赋值
                index = i;
              }
            });
            // 插入资格预审公告信息
            this.stepsList.splice(index + 1, 0, {
              name: "公告内容",
              isSave: false,
              isActive: true,
              formList: FormConfig.prequalificationInfo()
            });
          }
          // 不存在资格预审文件信息
          if (fileRtn) {
            // 资格预审公告信息插入位置
            let index = 0;
            // 遍历流程
            this.stepsList.map((e, i) => {
              // 资格预审公告信息
              if (e.name === "公告内容") {
                // 下标赋值
                index = i;
              }
            });
          }
          // 电子评审
          if (this.form.prequalificationShape === "0") {
            // 遍历
            this.stepsList.map(e => {
              // 匹配流程资格预审文件信息
              if (e.name === "公告内容") {
                // 遍历标签页
                e.formList.map(formList => {
                  // 遍历表单
                  formList.formConfigList.map((item, index) => {
                    // 匹配资格预审文件上传
                    if (item.value === "requisitionFilePath") {
                      // 删除
                      formList.formConfigList.splice(index, 1);
                    }
                  });
                });
              }
            });
            // 资格预审文件一览
            this.fun_PrequalificationFileList();
          } else {
            // 遍历
            this.stepsList.map(e => {
              // 匹配流程资格预审文件信息
              if (e.name === "公告内容") {
                // 遍历标签页
                e.formList.map(formList => {
                  // 遍历表单
                  formList.formConfigList.map((item, index) => {
                    // 匹配资格预审文件列表
                    if (item.slotName === "prequalificationList") {
                      // 删除
                      formList.formConfigList.splice(index, 1);
                    }
                  });
                });
              }
            });
          }
        }
      }
      // 如果是非电子标
      if (this.form.ebsFlag == "0") {
        // 匹配下标
        let bidDocumentSubmitEndDateIndex = 0;
        // 匹配数量
        let bidDocumentSubmitEndDateNum = 0;
        // 遍历
        this.stepsList.map(e => {
          // 匹配流程招标公告信息
          if (e.name === "项目信息") {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历表单
              formList.formConfigList.map((item, index) => {
                // 匹配文件下载截止时间
                if (item.value === "noticeEndDate") {
                  // 设置下标
                  bidDocumentSubmitEndDateIndex = index;
                }
                // 匹配投标文件递交截止时间
                else if (item.value === "bidDocumentSubmitEndDate") {
                  bidDocumentSubmitEndDateNum++;
                }
              });
            });
          }
        });
        // 如果不存在
        if(bidDocumentSubmitEndDateNum == 0){
          // 遍历
          this.stepsList.map(e => {
            // 匹配流程招标公告信息
            if (e.name === "项目信息") {
              // 遍历标签页
              e.formList.map(formList => {
                // 新增
                formList.formConfigList.splice(bidDocumentSubmitEndDateIndex + 1, 0, {
                    label: "投标文件递交截止时间：",
                    value: "bidDocumentSubmitEndDate",
                    type: "date",
                    dateType: "datetime",
                    disabled: false,
                    valueFormat: "yyyy-MM-dd HH:mm",
                    format: "yyyy-MM-dd HH:mm",
                    TimePickerOptions: {
                      disabledDate(time) {
                        //此条为设置禁止用户选择今天之前的日期，包含今天。
                        return time.getTime() <= (Date.now());
                      },
                    }
                  },
                );
              });
            }
          });
        }
      }
    },
    /**
     * 获取招标文件信息
     * @author shuhua
     */
    fun_TendererFileList() {
      // 打开加载
      this.loading = true;
      // 发起请求
      fun_PostAction("/tendererNotice/getFileList", {
        ...this.reqPageData,
        registrationId: this.form.registrationId,
        prequalificationType: "2"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 招标文件列表数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭加载
          this.loading = false;
        }
      });
    },
    /**
     * 资格预审文件信息一览
     * @author shuhua
     */
    fun_PrequalificationFileList() {
      // 打开加载
      this.preLoading = true;
      // 发起请求
      fun_PostAction("/tendererNotice/getFileList", {
        ...this.preReqPageData,
        registrationId: this.form.registrationId,
        prequalificationType: "1"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 招标文件列表数据
          this.preTableData = data.records;
          // 总条数
          this.preTotal = data.total;
          // 关闭加载
          this.preLoading = false;
        }
      });
    },
    /**
     * 招标文件/资格预审文件查看
     */
    fun_TendererNoticeFileLook(id, type){
      // 获取id
      fun_Download("/tendererNotice/getTendererNoticeFile?id=" + id + "&prequalificationType=" + type).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 存储this
          const data = new Blob([res.data], { type: "application/pdf" });
          this.pdfDialogVisible = true;
          this.pdfUrl =
              "./static/pdf/web/viewer.html?file=" +
              encodeURIComponent(URL.createObjectURL(data));
        }
      });
    },
    /**
     * 招标文件/资格预审文件下载
     */
    fun_TendererNoticeFileDownload(id, type){
      // 获取id
      fun_Download("/tendererNotice/getTendererNoticeFile?id=" + id + "&prequalificationType=" + type).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 异议部门信息一览
     * @author shuhua
     */
    fun_DissentDepartmentList() {
      // 打开加载
      this.objectionLoading = true;
      // 发起请求
      fun_PostAction("/tendererNotice/getDissentDepartmentList", {
        ...this.objectionReqPageData,
        registrationId: this.form.registrationId,
        prequalificationType: this.form.prequalificationType
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 招标文件列表数据
          this.objectionTableData = data;
          // 总条数
          this.objectionTotal = data.length;
          // 关闭加载
          this.objectionLoading = false;
        }
      });
    },
    /**
     * 获取标段下拉框的值
     * @author shuhua
     */
    fun_SetSectionCombobox() {
      // 发起请求
      fun_PostAction("/getSectionCombobox", {
        registrationId: this.form.registrationId
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 招标文件列表数据
          this.optionData = data;
        }
      });
    },
    /**
     * 清空
     * @author shuhua
     */
    fun_Clean() {
      // 清空招标登记编号
      this.form.registrationId = null;
      // 清空项目名称
      this.form.tenderPrjName = null;
      // 清空报建编号
      this.form.constructionNo = null;
      // 清空标段号
      this.form.sectionQuantity = null;
      // 清空资格核验方式
      this.form.prequalificationType = null;
      // 清空资格核验形式
      this.form.prequalificationShape = null;
      // 清空招投标监管部门
      this.form.regulators = null;
      // 清空电子标标志
      this.form.ebsFlag = null;
      // 清空评标办法
      this.form.evaluationMethod = null;
      // 清空招标计划主键
      this.form.biddingPlanId = null;
      // 清空投资项目代码
      this.form.planInvestProjectCode = null;
      // 清空投资项目名称
      this.form.planInvestProjectName = null;
      // 清空招标项目名称
      this.form.planProjectName = null;
      // 清空招标项目建设地点
      this.form.planProjectPlace = null;
      // 清空招标项目类型
      this.form.planTenderProjectTypeName = null;
      // 清空招标方式
      this.form.planTenderTypeName = null;
      // 清空招标人
      this.form.planTenderCorpName = null;
      // 清空发布人名称
      this.form.planIssueName = null;
      // 清空预估发包价（元）
      this.form.planContractPrice = null;
      // 清空招标公告预计发布时间
      this.form.planNoticeReleaseTime = null;
      // 清空发布时间
      this.form.planReleaseTime = null;
      // 清空招投标监管部门
      this.form.planRegulatorsName = null;
      // 清空项目概况
      this.form.planProjectOverview = null;
      // 清空招标内容
      this.form.planTenderContent = null;
      // 隐藏招标登记详情按钮
      this.isShowRegistration = false;
      // 隐藏招标计划按钮
      this.isShowPlanChoose = false;
    },
    /**
     * 招标计划赋值
     * @author shuhua
     */
    fun_BiddingPlan(id) {
      // 发起请求
      fun_PostAction("/biddingPlan/getBiddingPlanChosseDetail?id=" + id).then(
        res => {
          // 解构res.data
          const { result, data } = res.data;
          // 操作成功
          if (result) {
            // data不为空
            if (data) {
              // 判断是否插入招标计划信息
              let rtn = true;
              // 遍历流程
              this.stepsList.map(e => {
                // 匹配流程招标计划信息
                if (e.name === "招标计划信息") {
                  // 存在招标计划信息，赋值false
                  rtn = false;
                }
              });
              // 不存在招标计划信息
              if (rtn) {
                // 插入招标计划信息
                this.stepsList.splice(1, 0, {
                  name: "招标计划信息",
                  isSave: false,
                  isActive: true,
                  formList: FormConfig.biddingPlanInfo()
                });
              }
              // 设置招标计划主键
              this.form.biddingPlanId = data.id;
              // 设置投资项目代码
              this.form.planInvestProjectCode = data.investProjectCode;
              // 设置投资项目名称
              this.form.planInvestProjectName = data.investProjectName;
              // 设置招标项目名称
              this.form.planProjectName = data.projectName;
              // 设置招标项目建设地点
              this.form.planProjectPlace = data.projectPlace;
              // 设置招标项目类型
              this.form.planTenderProjectTypeName = data.tenderProjectTypeName;
              // 设置招标方式
              this.form.planTenderTypeName = data.tenderTypeName;
              // 设置招标人
              this.form.planTenderCorpName = data.tenderCorpName;
              // 设置发布人名称
              this.form.planIssueName = data.issueName;
              // 设置预估发包价（元）
              this.form.planContractPrice = data.contractPrice
                ? data.contractPrice.toString()
                : "";
              // 设置招标公告预计发布时间
              this.form.planNoticeReleaseTime = data.noticeReleaseTime;
              // 设置发布时间
              this.form.planReleaseTime = data.releaseTime;
              // 设置招投标监管部门
              this.form.planRegulatorsName = data.regulatorsName;
              // 设置项目概况
              this.form.planProjectOverview = data.projectOverview;
              // 设置招标内容
              this.form.planTenderContent = data.tenderContent;
              // 初始化时处理流程判断表单是否填写内容
              this.fun_GetInitializeStepsIsData();
              // 强制更新数据
              this.$forceUpdate();
            }
          }
        }
      );
    },
    /**
     * 获取变更记录
     * @author shuhua
     */
    fun_GetHistoryList() {
      // 打开遮罩
      this.modifyLoading = true;
      // 发出请求
      fun_PostAction("/noticeModifyInfo/list", {
        ...this.modifyForm,
        ...this.modifyReqPageData,
        announcementId: this.id
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 变更记录
          this.modifyTableData = data.records;
          // 总条数
          this.modifyTotal = data.total;
          // 关闭遮罩
          this.modifyLoading = false;
        } else {
          // 错误消息提示
          this.$message.error(msg);
          // 关闭遮罩
          this.modifyLoading = false;
        }
      });
    },
    /**
     * 下拉框标段值改变事件
     * @author shuhua
     */
    fun_ChangeBidNum(e) {
      // 赋值
      this.form.bidNum = e.code;
    },
    /**
     * 招标文件提交信息
     * @author shuhua
     */
    fun_SaveTenderFilePath() {
      // 定义formData
      let formData = new FormData();
      // 标段编号为空
      if (
        this.form.bidNum == "" ||
        this.form.bidNum == null ||
        this.form.bidNum == undefined
      ) {
        // 错误消息提示
        this.$message("请选择标段！", "error");
        return;
      }
      // 未上传招标文件
      if (this.tenderFile.length == 0) {
        // 错误消息提示
        this.$message("请选择招标文件！", "error");
        return;
      }
      // 招标文件
      formData.append("file", this.tenderFile[0].raw);
      // 标段号
      formData.append("id", this.form.bidNum);
      // 发起请求
      fun_UploadImg("/tendererNotice/saveTenderFilePath", formData, 0).then(
        res => {
          // 解构res.data
          const { result, msg } = res.data;
          // 操作成功
          if (result) {
            // 清空上传文件列表
            this.$refs.fileUpload.clearFiles();
            // 清空数组
            this.tenderFile = [];
            // 获取非电子标招标文件一览
            this.fun_TenderFilePathList();
            // 操作成功
            this.$message.success(msg);
          } else {
            // 返回错误消息
            this.$message.error(msg);
          }
        }
      );
    },
    /**
     * 获取非电子标招标文件一览
     * @author shuhua
     */
    fun_TenderFilePathList() {
      // 操作类型不等于查看详情，核验状态不等于通过
      if (this.controllerFlg != "detail" && this.form.isAuditOk != "tg") {
        // 表头按钮
        this.btnList = [
          {
            name: "删除",
            type: "danger",
            icon: "delete"
          }
        ];
      }
      // 打开遮罩
      this.nonEleLoading = true;
      // 发出请求
      fun_PostAction("/tendererNotice/getTenderFilePathList", {
        ...this.nonEleReqPageData,
        registrationId: this.form.registrationId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 变更记录
          this.nonEleTableData = data.records;
          // 总条数
          this.nonEleTotal = data.total;
          // 关闭遮罩
          this.nonEleLoading = false;
        } else {
          // 错误消息提示
          this.$message.error(msg);
          // 关闭遮罩
          this.nonEleLoading = false;
        }
      });
    },

    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "删除":
          // 执行删除的方法
          this.fun_DeleteTenderFile();
          break;
      }
    },

    /**
     * 删除招标文件（非电子标）
     * @author shuhua
     */
    fun_DeleteTenderFile() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 获取keys
          const keys = fun_GetKeys(this.multipleSelection);
          // 发起请求
          fun_GetAction("/tendererNotice/delTenderFilePath?keys=" + keys).then(
            res => {
              // 解构res.data
              const { result, msg } = res.data;
              // 操作成功
              if (result) {
                // 重新加载列表
                this.fun_TenderFilePathList();
                // 操作成功
                this.$message.success(msg);
              } else {
                // 错误消息提示
                this.$message.error(msg);
              }
            }
          );
        });
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },

    /**
     * 获取招标文件信息一览
     * @author shuhua
     */
    fun_EbTendererFileList() {
      // 打开加载
      this.loading = true;
      // 发起请求
      fun_PostAction("/tendererNotice/getFileList", {
        ...this.reqPageData,
        registrationId: this.form.registrationId,
        prequalificationType: "2"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 招标文件列表数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭加载
          this.loading = false;
        }
      });
    },

    /**
     * 资格预审上传文件
     * @author shuhua
     */
    fun_UploadFile(file, fileList) {
      // 获取文件后缀名
      const suffix = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      // 这里限定上传文件文件类型必须为PDF，如果文件类型不符，提示错误信息
      if (suffix === "doc" || suffix === "docx") {
        // 如果上传文件大于1
        if (fileList.length > 1) {
          // 根据下标删除列表中的文件
          this.$refs.upload.uploadFiles.splice(0, 1);
          // 清空数组
          this.prequalificationFile = [];
        }
        // 加入集合
        this.prequalificationFile.push(file);
      } else {
        // 根据下标删除列表中的文件
        this.$refs.upload.uploadFiles.splice(0, 1);
        // 清空上传的文件
        this.prequalificationFile = [];
        // 提示错误消息
        this.$message.error(
          "错误提示:上传文件应该为doc或docx格式，请重新选择文件后上传"
        );
        // 返回
        return false;
      }
    },

    /**
     * 招标文件上传
     * @author shuhua
     */
    fun_UploadTenderFile(file, fileList) {
      // 获取文件后缀名
      const suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      // 这里限定上传文件文件类型必须为PDF，如果文件类型不符，提示错误信息
      if (suffix === "PDF" || suffix === "pdf") {
        // 如果上传文件大于1
        if (fileList.length > 1) {
          // 根据下标删除列表中的文件
          this.$refs.fileUpload.uploadFiles.splice(0, 1);
          // 清空数组
          this.tenderFile = [];
        }
        // 加入集合
        this.tenderFile.push(file);
      } else {
        // 根据下标删除列表中的文件
        this.$refs.fileUpload.uploadFiles.splice(0, 1);
        // 清空上传的文件
        this.tenderFile = [];
        // 提示错误消息
        this.$message.error(
          "错误提示:上传文件应该为PDF格式，请重新选择文件后上传"
        );
        // 返回
        return false;
      }
    },

    /**
     * 打开上传附件弹窗
     * @author shuhua
     */
    fun_OpenUpload() {
      // 打开弹窗
      this.$refs.attachment.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.attachment.fun_GetOpen();
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_PreLimitChange(e) {
      // 获取每页显示条数
      this.preReqPageData.size = e;
      // 获取一览表格数据
      this.fun_PrequalificationFileList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PrePageChange(e) {
      // 获取当前页码
      this.preReqPageData.current = e;
      // 获取一览表格数据
      this.fun_PrequalificationFileList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_TendererFileList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_TendererFileList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_ObjectionLimitChange(e) {
      // 获取每页显示条数
      this.objectionReqPageData.size = e;
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_ObjectionPageChange(e) {
      // 获取当前页码
      this.objectionReqPageData.current = e;
    },
    /**
     * 变更记录查询方法
     * @author shuhua
     */
    fun_Search() {
      this.modifyReqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取变更记录一览
      this.fun_GetHistoryList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.modifyReqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetHistoryList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_ModifyLimitChange(e) {
      // 获取每页显示条数
      this.modifyReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetHistoryList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_ModifyPageChange(e) {
      // 获取当前页码
      this.modifyReqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetHistoryList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_NonEleLimitChange(e) {
      // 获取每页显示条数
      this.nonEleReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetHistoryList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_NonElePageChange(e) {
      // 获取当前页码
      this.nonEleReqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetHistoryList();
    },
    /**
     * 甲方确认
     */
    fun_GetTenderSignature(data) {
      if (data.tenderSignedState) this.tenderSignedState = data.tenderSignedState; // 招标人签章状态
      if (data.tenderOpinion) this.form.tenderOpinion = data.tenderOpinion; // 招标人意见
      if (data.data.table) this.tenderSignedForm.table = data.data.table; // 表名
      if (data.data.key) this.tenderSignedForm.key = data.data.key; // 字段
      if (data.data.id) this.tenderSignedForm.recordNumber = data.data.id; // 数据编号
      if (data.tenderOpinion) this.tenderSignedForm.tenderOpinion = data.tenderOpinion; // 招标人意见
      if (data.tenderSignedId) this.tenderSignedForm.tenderSignedId = data.tenderSignedId; // 招标人签章确认编号
      if (data.tenderSignedState) this.tenderSignedForm.tenderSignedState = data.tenderSignedState; // 招标人签章状态
      if (data.isDeregulation) this.tenderSignedForm.isDeregulation = data.isDeregulation; // 添加标记
      if (data.esRegulators) this.tenderSignedForm.esRegulators = data.esRegulators; // 招标人盖章确认的招标监管部门
      if (data.esProcessType) this.tenderSignedForm.esProcessType = data.esProcessType; // 招标人盖章确认的招标监管流程
      if (data.esInvitationId) this.tenderSignedForm.esInvitationId = data.esInvitationId; // 招标人盖章确认权限编号
      if (data.tenderStampData) this.tenderSignedForm.tenderStampData = data.tenderStampData; // 招标人盖章的数字签名
    },
    /**
     * 甲方确认提交与退还
     */
    fun_TenderStamp(e) {
      // 如果招标人意见不为空
      if (this.form.tenderOpinion != "" && this.form.tenderOpinion != null) {
        // 设置招标人意见
        this.tenderSignedForm.tenderOpinion = this.form.tenderOpinion;
      }
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data = this.form.id + this.form.tenderPrjName;
      // 状态
      this.$refs.caLock.state = e;
      this.$refs.caLock.tenderSigned = e;
      this.$refs.caLock.tenderSignedForm = this.tenderSignedForm;
    },

    /**
     * 点击流程
     */
    fun_GetClickSteps(val, index) {
      // 判断不是详情
      if (this.controllerFlg !== "detail") {
        // 如果是保存
        if (!this.form.tenderPrjName) {
          // 错误提示
          this.$alert("请优先选择招标项目信息！", "warning");
          return false;
        }
        // 是否填写当前表单
        if (this.fun_GetStepsIsData()) {
          // 设置当前流程已保存
          this.stepsList[this.stepsActive].isSave = true;
        }
        // 如果不是通过
        if(this.form.state != "tg"){
          // 状态
          this.form.state = "bc";
          // 提交的方法
          this.fun_Submit();
        }
      }
      // 赋值下标
      this.stepsActive = index;
      // 获取表单数据
      this.formConfigList = val.formList;
    },

    /**
     * 上一步
     */
    fun_GetLastStep() {
      // 判断不是详情
      if (this.controllerFlg !== "detail") {
        // 如果是保存
        if (!this.form.tenderPrjName) {
          // 错误提示
          this.$alert("请优先选择招标项目信息！", "warning");
          return false;
        }
        // 如果不是通过
        if(this.form.state != "tg"){
          // 状态
          this.form.state = "bc";
          // 提交的方法
          this.fun_Submit();
        }
      }
      // 减1
      this.stepsActive--;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 下一步
     */
    fun_GetNextStep() {
      // 如果是详情
      if (this.controllerFlg == "detail") {
        // 设置当前流程已保存
        this.stepsList[this.stepsActive].isSave = true;
        // 加1
        this.stepsActive++;
        // 设置下一个流程可点击
        this.stepsList[this.stepsActive].isActive = true;
        // 获取表单数据
        this.formConfigList = this.stepsList[this.stepsActive].formList;
      }
      // 如果不是详情
      else {
        // 验证表单
        // this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        // if (valid) {
        // 投资总额转为Number
        this.form.totalInvestment = Number(this.form.totalInvestment);
        // 招标文件发售价格转为Number
        this.form.offerPrice = Number(this.form.offerPrice);
        // 如果是保存
        if (!this.form.tenderPrjName) {
          // 错误提示
          this.$alert("请优先选择招标项目信息！", "warning");
          return false;
        }
        // 是否填写当前表单
        if (this.fun_GetStepsIsData()) {
          // 设置当前流程已保存
          this.stepsList[this.stepsActive].isSave = true;
        }
        // 如果不是通过
        if(this.form.state != "tg"){
          // 状态
          this.form.state = "bc";
          // 提交的方法
          this.fun_Submit();
        }
        // 加1
        this.stepsActive++;
        // 设置下一个流程可点击
        this.stepsList[this.stepsActive].isActive = true;
        // 获取表单数据
        this.formConfigList = this.stepsList[this.stepsActive].formList;
      }
    },

    /**
     * 勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值
      this.multipleSelection = e;
    },

    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 监听滚动
     */
    fun_HandleScroll(e) {
      // 判断
      if (e.target.offsetTop < this.$refs.sticky.offsetTop) {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "0 0 8px 3px rgba(0, 0, 0, 0.06)";
      } else {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "none";
      }
    },

    /**
     * 招标登记信息弹窗打开后执行
     */
    fun_BidDialogOpen() {
      // 打开
      this.isBidDialogOpen = true;
      // 执行
      this.$nextTick(() => {
        // 隐藏顶部
        this.$refs.biddingRegistration.pageHeader = false;
        // 招标登记表主键
        this.$refs.biddingRegistration.id = this.form.registrationId;
        // 查看详情
        this.$refs.biddingRegistration.controllerFlg = "detail";
        // 获取详情
        this.$refs.biddingRegistration.fun_GetDetail();
      });
    },
    /**
     * 初始化时处理流程判断表单是否填写内容
     */
    fun_GetInitializeStepsIsData() {
      // 遍历流程数据
      this.stepsList.map((item, index) => {
        // 遍历表单内容
        item.formList.map(formList => {
          // 遍历表单字段
          formList.formConfigList.map(form => {
            // 判断是否填写内容
            if (this.form[form.value]) {
              // 改变状态
              item.isSave = true;
            }
          });
        });
      });
    },
    /**
     * 用于判断当前流程是否填写数据
     */
    fun_GetStepsIsData() {
      // 声明
      var formArr = []; // 所有表单
      var isFormKey = false; // 是否填写
      // 遍历获取所有表单数据
      this.formConfigList.map(item => {
        // 判断是否存在表单
        if (item.formConfigList && item.formConfigList.length > 0)
          formArr.push(...item.formConfigList);
      });
      // 判断当前表单
      for (var i = 0; i < formArr.length; i++) {
        // 判断字段是否填写值
        if (this.form[formArr[i].value]) {
          // 改变标识
          isFormKey = true;
          // 跳出循环
          break;
        }
      }
      return isFormKey;
    },
    /**
     * 返回工作台
     */
    fun_BackStaff(){
      // 跳转工作台
      this.$router.push({path: "/staffWorkbench" });
    },
  }
};
